import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import {
  map, Observable, throwError, catchError 
} from 'rxjs';
import { environment } from 'src/environments/environment';
import { SuperFundDetails } from '../../interfaces/abn/superFundDetails';

@Injectable({
  providedIn: 'root',
})
export class ABNLookupService {
  private readonly apiUrl = `${environment.teamSalaryBackendUrl}/superfund-lookup`;

  constructor(private http: HttpClient) {}

  searchSuperFundsByABN(abnNumber: string): Observable<SuperFundDetails | null> {
    const params = new HttpParams().set('abn', abnNumber);

    return this.http.get<SuperFundDetails | null>(this.apiUrl, { params, observe: 'response' }).pipe(
      map((response) => {
        if (response.status === 204) {
          return null;
        }

        return response.body;
      }),
      catchError((error) => throwError(() => new Error(`Error while looking up ABN: ${error}`)))
    );
  }
}
